import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';

const CloseIcon = ({
	onClick,
	value,
	tooltip = 'Rechazar',
	colorName = '',
	className,
}) => {
	return (
		<Tooltip title={tooltip} onClick={onClick}>
			<Close style={{ color: colorName }} className={className} />
		</Tooltip>
	);
};

export default CloseIcon;
